module.exports = __webpack_public_path__ + "img/baja-bins.5fe3eb69.png";